import { useNavigate } from 'react-router-dom';
import Avatar from '@components/ui/Avatar';
import { usePublicConfig } from '@context/PublicConfigContext';
import { resolveProfileDisplaySrc } from '@utils/profileImageSrc';
import api from '@utils/api';
import { formatInboxTime } from '@utils/helpers';
import { useNotifications } from '@context/NotificationContext';
import { INBOX_READ_ROW, INBOX_ROW_FRAME, INBOX_UNREAD_ROW } from '@components/messages/inboxRowStyles';

const RatingInboxCard = ({ n, onRatingRead, isPulsing = false }) => {
  const { siteOrigin } = usePublicConfig();
  const navigate = useNavigate();
  const { refreshUnreadCount } = useNotifications();
  const sender = n.senderId;
  const notifId = n._id ?? n.id;
  const headline =
    n.rating != null ? `${sender?.name || 'Someone'} rated you ${n.rating}⭐` : sender?.name || 'Someone';

  const handleClick = async () => {
    try {
      if (!n.isRead && notifId) {
        await api.patch(`/notifications/${notifId}/read`);
        await onRatingRead?.(notifId);
      }
    } catch {
      /* still refresh + navigate */
    }
    await refreshUnreadCount();
    navigate('/profile#ratings');
    setTimeout(() => window.dispatchEvent(new CustomEvent('Yaarvi:scroll-profile-ratings')), 0);
  };

  const unread = !n.isRead;

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`${INBOX_ROW_FRAME} ${unread ? INBOX_UNREAD_ROW : INBOX_READ_ROW} ${
        isPulsing ? 'animate-pulse-glow' : ''
      }`}
    >
      <Avatar name={sender?.name} src={resolveProfileDisplaySrc(sender, siteOrigin)} size="md" className="shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between gap-2">
          <p className="font-semibold text-surface-900 dark:text-surface-50">{headline}</p>
          <span className="shrink-0 text-xs text-surface-400">{formatInboxTime(n.createdAt)}</span>
        </div>
        <p className="mt-1 truncate text-sm text-surface-500 opacity-90 dark:text-surface-400">{n.message}</p>
      </div>
    </button>
  );
};

export default RatingInboxCard;
